import { put, call } from "redux-saga/effects";
import { azureConstants } from "../actions/constants/azureConstants";
import { AzureService } from "../services/api/azureService";
import { exceptionHandler } from "../pages/common/functions";

function* getUserUsageMetric() {
	try {
		const result = yield call(AzureService.getUserUsageMetric);		
		var res = exceptionHandler(result);		
		if (res.status) {
			yield put({
				type: azureConstants.GetUserUsageMetricsSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: azureConstants.GetUserUsageMetricsFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: azureConstants.GetUserUsageMetricsFailure, payload: error });
	}
}


export const azureSaga = {
	getUserUsageMetric
}